import React, { useMemo } from 'react';
import { SignatureSectionProps } from 'types/DetailPageTypes';
import { useTranslation } from 'react-i18next';
import { Signature } from '../../views/attachment/AttachmentTypes';
import '../../style/scss/card.scss';

const SignatureSection: React.FC<SignatureSectionProps> = ({
    data, loadStatus
}) => {
    const { t } = useTranslation();

    // Set the current signatures
    const signatures = useMemo(() => {
        if (!data) return [];
        return data;
    }, [data]);

    // Function to format the date based on the local timezone and format
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleString(undefined, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    };

    // Get the most recent signature
    const getLatestSignature = (type: 'client' | 'field_worker') => {
        return signatures
            .filter((signature: Signature) => signature.signed_by === type)
            .sort((a: Signature, b: Signature) =>
                new Date(b.created).getTime() - new Date(a.created).getTime()
            )[0] || null;
    };

    // Get the most recent client and field worker signature
    const clientSignature = getLatestSignature('client');
    const workerSignature = getLatestSignature('field_worker');

    return (
        (clientSignature || workerSignature) ? (
            <div className="card signaturecard">
                <h6>{t('job.signatures.signatures_label')}</h6>

                {loadStatus === "loading" ? (
                    <div className="loader"></div>
                ) : (
                    <div className="signatures-row">
                        {clientSignature && (
                            <div className="signature-box">
                                <img src={clientSignature.file}
                                    alt={clientSignature.filename}
                                    className="signature-image"
                                />
                                <div className="signature-data">
                                    <p>{clientSignature.signer_name} - {t('job.signatures.client_label')}</p>
                                    <p className='subtile'>{formatDate(clientSignature.created)}</p>
                                    <p className='subtile'>{clientSignature.signer_email}</p>
                                </div>
                            </div>
                        )}
                        
                        {workerSignature && (
                            <div className="signature-box">
                                <img src={workerSignature.file}
                                    alt={workerSignature.filename}
                                    className="signature-image"
                                />
                                <div className="signature-data">
                                    <p>{workerSignature.signed_by_user_full_name} - {t('job.signatures.field_worker_label')}</p>
                                    <p className='subtile'>{formatDate(workerSignature.created)}</p>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        ) : null 
    );
};

export default SignatureSection;